const state = {
  inputFocus: false,
};

const mutations = {
  PAGE_INDEX_FOCUS(state) {
    state.inputFocus = true;
  },
  PAGE_INDEX_BLUR(state) {
    state.inputFocus = false;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  inputFocus: (state) => {
    return state.inputFocus;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
